import { Dropdown } from 'react-bootstrap';
import { Loadable } from '../..';
import { BoltOnItem, DropdownItem, TariffDropdownItem } from '../../../components/ui/input/DropdownInput';
import { HashMap } from '../../../constants';
import { LoadBoltOnsPayload, LoadCommandStocksPayload } from '../../payload/loadRequests';
import { SubmissionCommand } from '../commands';

export type SubmissionState = Loadable<{
  name: string;
  actionDate?: Date;
  delayAction: boolean;
  params: LoadCommandStocksPayload;
  simCommands: SubmissionCommand[];
  simDefinitionAliases: string[];
}>;

export interface SimProvisionState {
  /** The bolt-ons state. */
  boltOns: BoltOnsState;

  /** Days on which provisioning is not allowed */
  excludedProvisioningDays: ExcludedProvisioningDaysState;

  /** The bundle top-ups state. */
  bundleTopupSizes: DropdownItemsState;

  /** The tariffs state. */
  tariffs: TariffDropdownItemsState;

  /** The temporal bolt-ons state. */
  temporalBoltOns: BoltOnsState;
}

export interface BoltOnState {
  availableBoltOns: Loadable<{
    byId: HashMap<BoltOnItem>;
    items: BoltOnItem[];
  }>;

  selection: LoadBoltOnsPayload;
}

export type ExcludedProvisioningDaysState = Loadable<{
  commandDefinitionIds: string;
  items: string[];
}>;

export type DropdownItems = Loadable<{
  items: DropdownItem[];
  byId: HashMap<DropdownItem>;
}>;

export type TariffDropdownItems = Loadable<{
  items: TariffDropdownItem[];
  byId: HashMap<DropdownItem>;
}>;

/** Holds state related to available tariff drop down options */
export type TariffDropdownItemsState = HashMap<TariffDropdownItems>;

/** Holds state related to available drop down options */
export type DropdownItemsState = HashMap<DropdownItems>;

/** Holds state related to the provisioning bolt-ons drop down, indexed by network. */
export type BoltOnsState = HashMap<BoltOnState>;

/** Holds state related to orange provisioning zones (the full list of commonly used zones, not just those permitted */
export type OrangeZonesState = Loadable<{
  all: DropdownItem[];
  allById: HashMap<DropdownItem>;
  enabled: DropdownItem[];
  enabledById: HashMap<DropdownItem>;
}>;

/** Holds state related to mvno provisioning templates */
export type MvnoTemplatesState = Loadable<{
  all: DropdownItem[];
  allById: HashMap<DropdownItem>;
  enabled: DropdownItem[];
  enabledById: HashMap<DropdownItem>;
}>;

/** Holds information about the zones permitted on an account. */
export type AccountOrangeZonesState = OrangeZonesState & {
  accountId: number;
};

/**
 * Gets account network key.
 * @param accountId The account identifier
 * @param networkId The network identifier
 */
export function getAccountNetworkKey(accountId: number, networkId: number) {
  return `${networkId}_${accountId}`;
}

export function getDefaultMvnoTemplatesState() {
  return {
    all: [],
    allById: {},
    enabled: [],
    enabledById: {},
    isLoading: false,
  };
}
